export default "__VITE_PUBLIC_ASSET__8a178b67__"